<template>
    <v-alert v-model="alertVisible" :text="alertText" :type="alertType" :closable="isDismissible" class="headerNotification" @update:model-value="setVisible">
    </v-alert>
</template>

<script lang="ts">
import { Component, Watch, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';
const headerNotificationModul = namespace(NAME_HEADERNOTIFICATION);
import { GET_VISIBLE, GET_TYPE, GET_TEXT, GET_CLOSEDELAY, GET_CLOSEAFTERDELAY, GET_DISMISSIBLE } from '@/store/modules/headerNotification/getters';

import { SET_VISIBLE } from '@/store/modules/headerNotification/mutations';

import { CLOSE } from '@/store/modules/headerNotification/actions';

@Component
export default class HeaderNotification extends Vue {
    @headerNotificationModul.Getter(GET_VISIBLE) alertVisible!: boolean;
    @headerNotificationModul.Getter(GET_TYPE) alertType!: string;
    @headerNotificationModul.Getter(GET_TEXT) alertText!: string;
    @headerNotificationModul.Getter(GET_CLOSEDELAY) closeDelay!: number;
    @headerNotificationModul.Getter(GET_CLOSEAFTERDELAY) closeAfterDelay!: boolean;
    @headerNotificationModul.Getter(GET_DISMISSIBLE) isDismissible!: boolean;

    @headerNotificationModul.Action(CLOSE) close!: Function;

    @headerNotificationModul.Mutation(SET_VISIBLE) setVisible!: Function;

    @Watch('alertVisible')
    onVisibleChangedOpen() {
        console.log('alert visible changed');
        if (this.alertVisible) {
            if (this.closeAfterDelay && this.closeDelay > 0) {
                setTimeout(() => {
                    this.close();
                }, this.closeDelay);
            }
        }
    }
    closeClicked() {
        this.close();
    }
}
</script>

<style></style>
